import { render } from "./HeroiconsOutlineDotsVertical.vue?vue&type=template&id=8e5f0efe"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDotsVertical.vue"]])

export default __exports__